'use client'

import { useEffect, useState } from 'react'

import dynamic from 'next/dynamic'

import { Place } from '@/types'

const MapComponent = dynamic(() => import('./MapComponent'), {
  ssr: false,
  loading: () => <div className="h-96 bg-gray-100 animate-pulse rounded-lg" />
})

interface InteractiveMapProps {
  places: Place[]
  destination: string | { name: string; value: string }
  category: string
}

const InteractiveMap = ({
  places,
  destination,
  category
}: InteractiveMapProps) => {
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setMounted(true)
    return () => setMounted(false)
  }, [])

  if (!mounted || !places || places.length === 0) {
    return <div className="h-96 bg-gray-100 animate-pulse rounded-lg" />
  }

  return (
    <div className="h-96 mb-8 relative z-0">
      <MapComponent
        key={`map-${places.length}`}
        places={places}
        destination={destination}
        category={category}
      />
    </div>
  )
}

export default InteractiveMap
